/* import __COLOCATED_TEMPLATE__ from './step.hbs'; */
/* RESPONSIBLE TEAM: team-integration-apps */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';

export interface Args {
  onBack?: () => void;
  onNext?: () => void;
}

interface Signature {
  Args: Args;
  Element: HTMLElement;
  Blocks: {
    default: [];
  };
}

export default class Step extends Component<Signature> {
  @service declare intl: IntlService;

  translation = (path: string) => this.intl.t(this.translationKey(path));
  private translationKey = (path: string) =>
    `new-settings.data.imports-exports.import-zendesk.config-import-page.sections.ticket.buttons.${path}`;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Data::ImportsExports::ImportZendesk::ConfigImport::Sections::Lib::Step': typeof Step;
    'new-settings/data/imports-exports/import-zendesk/config-import/sections/lib/step': typeof Step;
  }
}
